/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from "react";

/**
 * Simple tab bar component using Tailwind styling.
 *
 * @param {{ tabs: {key: string, label: string, icon?: React.ReactNode}[], activeTab: string, onChange: (key: string) => void, className?: string }} props
 */
export function Tabs({ tabs, activeTab, onChange, className = "" }) {
  return (
    <div className={`flex border-b border-borderDefault ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onChange(tab.key)}
          className={`
            flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-colors
            border-b-2 -mb-px
            ${
              activeTab === tab.key
                ? "border-primary text-primary"
                : "border-transparent text-textSecondary hover:text-textPrimary hover:border-borderDefault"
            }
          `}
        >
          {tab.icon && <span className="w-4 h-4">{tab.icon}</span>}
          {tab.label}
        </button>
      ))}
    </div>
  );
}

/**
 * Tab panel — renders children only when active.
 *
 * @param {{ tabKey: string, activeTab: string, children: React.ReactNode, className?: string }} props
 */
export function TabPanel({ tabKey, activeTab, children, className = "" }) {
  if (tabKey !== activeTab) return null;
  return <div className={`pt-4 ${className}`}>{children}</div>;
}
